<div class="bg-white rounded-2xl border-secondary border-2 p-8 w-150 h-52">
  @if (this.storageUploadStateService; as storageStateService) {
    <h1 class="truncate" [title]="storageStateService.file().name">{{ storageStateService.file().name }}</h1>

    <div class="flex flex-row gap-2 p-2">
      <mat-icon
        class="cursor color-gray-500 material-symbols-outlined"
      >
        info
      </mat-icon>
      @if (storageStateService.fileUploadState() === FileUploadState.PENDING) {
        <span>{{ 'UPLOAD_DIALOG.STATES.PENDING' | translate }}</span>
      }

      @if (storageStateService.fileUploadState() === FileUploadState.UPLOADING) {
        <span>{{ 'UPLOAD_DIALOG.STATES.UPLOADING' | translate }}</span>
      }

      @if (storageStateService.fileUploadState() === FileUploadState.PAUSED) {
        <span>{{ 'UPLOAD_DIALOG.STATES.PAUSED' | translate }}</span>
      }

      @if (storageStateService.fileUploadState() === FileUploadState.FINALIZING) {
        <span>{{ 'UPLOAD_DIALOG.STATES.FINALIZING' | translate }}</span>
      }

      @if (storageStateService.fileUploadState() === FileUploadState.COMPLETED) {
        <span>{{ 'UPLOAD_DIALOG.STATES.COMPLETED' | translate }}</span>
      }

      @if (storageStateService.fileUploadState() === FileUploadState.ERROR) {
        <span>{{ 'UPLOAD_DIALOG.STATES.ERROR' | translate }}</span>
      }
    </div>

    <div class="flex flex-row gap-4 items-center">
      <div class="w-96 h-8 bg-white border-2 border-gray-400 rounded-xl">
        <div
          class="h-full bg-green-200 rounded-xl"
          [ngClass]="{
            'w-full bg-red-200': storageStateService.fileUploadState() === FileUploadState.ERROR
          }"
          [ngStyle]="{ width: storageStateService.fileUploadChunksProgress() + '%' }"
        ></div>
      </div>

      <div>
        @if (storageStateService.fileUploadState() === FileUploadState.UPLOADING) {
          <button
            class="custom-button rounded-full! w-30 h-10 mb-2"
            (click)="storageStateService.pauseUploading()">
            {{ 'UPLOAD_DIALOG.BUTTONS.PAUSE' | translate }}
          </button>
        }

        @if (storageStateService.fileUploadState() === FileUploadState.PAUSED || storageStateService.fileUploadState() === FileUploadState.ERROR) {
          <button
            class="custom-button rounded-full! w-30 h-10 mb-2"
            (click)="storageStateService.resumeUploading()">
            {{ 'UPLOAD_DIALOG.BUTTONS.RESUME' | translate }}
          </button>
        }

        @if (storageStateService.fileUploadState() === FileUploadState.PAUSED || storageStateService.fileUploadState() === FileUploadState.PENDING) {
          <button
            class="custom-button rounded-full! w-30 h-10 mb-2"
            (click)="storageStateService.cancelUploading()">
            {{ 'UPLOAD_DIALOG.BUTTONS.CANCEL' | translate }}
          </button>
        }

        @if (storageStateService.fileUploadState() === FileUploadState.COMPLETED || storageStateService.fileUploadState() === FileUploadState.ERROR) {
          <button
            class="custom-button rounded-full! w-30 h-10 mb-2"
            (click)="storageStateService.closeFileUpload()">
            {{ 'UPLOAD_DIALOG.BUTTONS.CLOSE' | translate }}
          </button>
        }
      </div>
    </div>
  }
</div>
